import { TableAccordionConfig } from "./types";

export const dvrAccordion: TableAccordionConfig = {
  keys: [],
  shownIndex: -1,
  tableItems: [],
  tableItemsToShow: []
};